import MeaPage from "../../../components/MeaPage";
import { useRef, useState } from "react";
import { useLoaderData, useLocation, useNavigate, useParams } from "react-router-dom";
import TeachersListComponent from "./components/TeachersListComponent";
import MeaPermissionGuard from "../../../components/MeaPermissionGuard";
import { PERMISSION_TRAINING_TEACHERS } from "../../../permissions";
import SecretariatWorkspaceBar from "../../secretariat/components/SecretariatWorkspaceBar";
import MeaButton from "../../../components/MeaButton";
import { Dialog } from "primereact/dialog";
import moment from "moment-timezone";

const TeachersListPage = () => {
  const { training } = useLoaderData();
  const { schoolId, trainingId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const listRef = useRef();
  const [selectedMonth, setSelectedMonth] = useState();
  const [showPrintOptions, setShowPrintOptions] = useState(false);
  const currentMonth = moment.tz("Europe/Paris").format("YYYY-MM");
  const isSecretariatRoute = location.pathname.includes("/secretariat/");
  const printPath = isSecretariatRoute
    ? `/school/${schoolId}/secretariat/teachers/${trainingId}/print-all-teachers`
    : `/school/${schoolId}/admin/trainings/${trainingId}/teachers/print-all-teachers`;
  const printMonth = (month) => navigate(`${printPath}?teacherMonth=${month}`);
  const printButton = (
    <MeaButton
      label="Imprimer"
      icon="pi pi-print"
      permission={PERMISSION_TRAINING_TEACHERS.LIST}
      disabled={!selectedMonth}
      onClick={() => setShowPrintOptions(true)}
    />
  );
  const fallbackTo = isSecretariatRoute
    ? `/school/${schoolId}/secretariat/teachers`
    : `/school/${schoolId}/admin/trainings/${trainingId}/info`;
  
  return (
    <MeaPermissionGuard
      permission={PERMISSION_TRAINING_TEACHERS.LIST}
      fallbackTo={fallbackTo}
    >
      <MeaPage
        title="Liste des enseignant(e)s"
        subtitle="Gérer l'ensemble des enseignant(e)s de cette formation"
        customActions={printButton}
        {...(isSecretariatRoute && {
          breadcrumb: <SecretariatWorkspaceBar section="teachers" training={training} />,
          showBackButton: true,
          onBackButtonClick: () => navigate(`/school/${schoolId}/secretariat`),
        })}
      >
        <Dialog
          header="Choisir la période à imprimer"
          visible={showPrintOptions}
          onHide={() => setShowPrintOptions(false)}
          style={{ width: "30rem", maxWidth: "95vw" }}
        >
          <div className="flex flex-column gap-3">
            <MeaButton
              label={`Mois en cours (${moment(currentMonth, "YYYY-MM").locale("fr").format("MMMM YYYY")})`}
              onClick={() => printMonth(currentMonth)}
            />
            {selectedMonth && selectedMonth !== currentMonth && (
              <MeaButton
                label={`Mois sélectionné (${moment(selectedMonth, "YYYY-MM").locale("fr").format("MMMM YYYY")})`}
                onClick={() => printMonth(selectedMonth)}
              />
            )}
            <MeaButton
              label="Toute la période (un tableau par mois)"
              onClick={() => navigate(`${printPath}?printPeriod=all`)}
            />
          </div>
        </Dialog>
        <TeachersListComponent
          ref={listRef}
          training={training}
          onMonthChange={setSelectedMonth}
          showAddButton={true}
          showFilterButton={true}
        />
      </MeaPage>
    </MeaPermissionGuard>
  );
};
export default TeachersListPage;
